module.exports = __webpack_public_path__ + "img/camping--mobile.10231d6f.jpg";